import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

// actions
import { closeBadger, selectBadger } from '@/store/ui/uiSlice';

// components
import PortalWrapper from '@/components/Portal/PortalWrapper';
import { CloseIcon, CheckIcon, InfoIcon } from '@/components/sushi__old';

const delayBeforeClose = 10000;

const Badger = () => {
  const dispatch = useDispatch();
  const i18n = useIntl();
  const {
    badger: { isOpen, key, error, i18nParams = {}, message },
  } = useSelector(selectBadger);

  let badgerMessage = message;
  if (key) {
    badgerMessage = i18n.formatMessage({ id: key }, i18nParams);
  }

  const handleClose = useCallback(() => {
    dispatch(closeBadger());
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        handleClose();
      }, delayBeforeClose);
      return () => clearTimeout(timer);
    }
  }, [handleClose, isOpen]);

  return (
    <>
      {isOpen && (
        <PortalWrapper selector="#badger">
          <div
            role="alert"
            className={classNames({
              'rounded-sm px-1 pr-3 p-2 text-white font-semibold fixed left-2 bottom-2 flex items-center justify-start': true,
              badger: !error,
              'badger-error': error,
            })}
          >
            {!error ? (
              <CheckIcon color="#fff" size="xmedium" />
            ) : (
              <InfoIcon color="#fff" size="xmedium" />
            )}
            <div>
              <p className="ml-1 text-14 font-semibold">{badgerMessage}</p>
            </div>
            <div>
              <button type="button" onClick={handleClose} className="absolute right-1 top-1 w-2">
                <CloseIcon size="small" color="white" />
              </button>
            </div>
          </div>
          <style jsx>{`
            .badger-error {
              background: rgba(229, 73, 73, 1);
            }
            .badger {
              background: #1fc090;
              z-index: 5;
            }
            @media screen and (max-width: 992px) {
              .badger {
                top: 0;
                bottom: initial;
                z-index: 42;
                width: 90vw;
                margin: 20px auto;
              }
            }
          `}</style>
        </PortalWrapper>
      )}
    </>
  );
};

export default Badger;
